export default __webpack_public_path__ + "static/media/marca.8ce5b3aa.jpg";